import { render } from "./SessionTimeOutNewUser.vue?vue&type=template&id=06e1b275&scoped=true"
import script from "./SessionTimeOutNewUser.vue?vue&type=script&lang=js"
export * from "./SessionTimeOutNewUser.vue?vue&type=script&lang=js"

import "./SessionTimeOutNewUser.vue?vue&type=style&index=0&id=06e1b275&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e1b275"]])

export default __exports__